import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { VerwaltungsView } from './wartung.types';
import { SOTYP_Map } from 'src/app/models/api/SOTYP';
import { Subject } from 'rxjs';
import { APIService } from 'src/app/services/APIService/api.service';
import { WartungsBaumComponent } from './wartungsbaum/wartungsbaum.component';
import { WartungsItemComponent } from './wartungsbaum/wartungsitem/wartungsitem.component';
import { WartungsMaskenComponent } from './wartungsmasken/wartungsmasken.component';
import { WartungsObjektZuordnungComponent } from './wartungsobjektzuordnung/wartungsobjektzuordnung.component';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';

import { FormsModule } from '@angular/forms';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { WartungsZaehlerZuordnungComponent } from './wartungszaehlerzuordnung/wartungszaehlerzuordnung.component';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-wartungsverwaltung',
  templateUrl: './wartungsverwaltung.component.html',
  styleUrls: ['./wartungsverwaltung.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    WartungsBaumComponent,
    WartungsItemComponent,
    WartungsMaskenComponent,
    WartungsObjektZuordnungComponent,
    WartungsZaehlerZuordnungComponent,
    MrTranslatePipe,
    FormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WartungsVerwaltungComponent {
  public closedialog = new Subject();
  protected dataRefresh: Subject<void>;
  readonly #apiService = inject(APIService);

  protected openView = signal<VerwaltungsView | 'home'>('home');

  protected readonly objekte = toSignal<SOTYP_Map>(this.#apiService.getSOTYP());
  protected readonly otypid = signal<number>(undefined);

  public set data(dataIn: any) {
    if (dataIn?.recalledData) {
      this.otypid.set(dataIn.recalledData.otypid);
      this.openView.set(dataIn.recalledData.openView);
    }
    this.dataRefresh = dataIn.dataRefresh;
  }

  constructor() {
    const ref = effect(() => {
      if (this.otypid() === undefined) {
        for (const id in this.objekte()) {
          this.otypid.set(+id);
          break;
        }
      } else ref.destroy();
    });
  }

  protected close() {
    this.closedialog.next(true);
  }
}
